import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=22d0c9ad&scoped=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&id=22d0c9ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0c9ad",
  null
  
)

export default component.exports